/**
 * @typedef {Object} BookingGradeViewModelType
 * @property {number} id - Unique identifier
 * @property {string} title - The  name for the grade
 */

/**
 * @class
 */
export default class BookingGradeViewModel {
  /**
   * Create a new BookingGradeViewModel.
   * @param {...BookingGradeViewModelType} params
   */
  constructor(params) {
    this.id = params.id
    this.title = params.title
  }
}
